import React from 'react';
import Navbar from '../../Components/Navbar/Navbar';
import Footer from '../../Components/Footer/Footer';
import './MessagesPage.css';
import unavailableIcon from '../../assets/images/8373782.png'; // pridaj vlastný obrázok

const MessagesPage = () => {
    return (
        <div>
            <Navbar />

            <div className="messages-page-container" style={{ marginTop: "120px", minHeight: "70vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <div className="unavailable-card">
                    <img src={unavailableIcon} alt="Unavailable" className="unavailable-icon" />
                    <h2>Táto funkcionalita nie je dostupná v tomto režime</h2>
                    <p>Budete sa musieť prihlásiť na oficialnej stránke</p>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default MessagesPage;
